export const platformAccess = {
  junior: {
    required: [
      { platform: 'GitHub', access: 'Developer', purpose: 'Full-stack repository access', setup: 'Request access to both frontend and backend repos' },
      { platform: 'Jira', access: 'Developer', purpose: 'Full-stack task tracking', setup: 'Account with full-stack project access' },
      { platform: 'Slack', access: 'Member', purpose: 'Cross-team communication', setup: 'Join #fullstack-team, #frontend, #backend channels' },
      { platform: 'AWS Console', access: 'ReadOnly', purpose: 'Infrastructure monitoring', setup: 'Request IAM user with read permissions' }
    ],
    optional: [
      { platform: 'Postman Team', access: 'Collaborator', purpose: 'API testing and documentation', setup: 'Join team workspace' },
      { platform: 'Figma', access: 'Viewer', purpose: 'Design system access', setup: 'Request access to design files' }
    ]
  },
  mid: {
    required: [
      { platform: 'AWS Console', access: 'Developer', purpose: 'Deploy full-stack applications', setup: 'Request elevated IAM permissions' },
      { platform: 'Vercel/Netlify', access: 'Developer', purpose: 'Frontend deployment', setup: 'Connect GitHub repos' },
      { platform: 'Database Console', access: 'Developer', purpose: 'Database management', setup: 'Access to staging and production DBs' },
      { platform: 'Monitoring Tools', access: 'Standard', purpose: 'Full-stack monitoring', setup: 'New Relic/Datadog access' }
    ],
    optional: [
      { platform: 'Sentry', access: 'Member', purpose: 'Error tracking', setup: 'Join full-stack projects' },
      { platform: 'Docker Hub', access: 'Developer', purpose: 'Container registry', setup: 'Organization member access' }
    ]
  },
  senior: {
    required: [
      { platform: 'AWS Console', access: 'Admin', purpose: 'Full infrastructure management', setup: 'Request admin IAM role' },
      { platform: 'GitHub', access: 'Admin', purpose: 'Repository and team management', setup: 'Admin access to organization' },
      { platform: 'CI/CD Platform', access: 'Admin', purpose: 'Pipeline management', setup: 'Admin access to Jenkins/GitHub Actions' },
      { platform: 'Monitoring Platform', access: 'Admin', purpose: 'System observability', setup: 'Admin role in monitoring tools' }
    ],
    optional: [
      { platform: 'Kubernetes Dashboard', access: 'Admin', purpose: 'Container orchestration', setup: 'Cluster admin permissions' },
      { platform: 'Terraform Cloud', access: 'Admin', purpose: 'Infrastructure as code', setup: 'Organization admin role' }
    ]
  }
};
